import React from 'react';

// Styles
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export const ModalRemoveItemDraw = ({ confirmDelete, setConfirmDelete, handleDeleteDraw }) => {
  return (
    <Dialog
      open={confirmDelete.open}
      onClose={() => setConfirmDelete({ open: false, index: null })}
    >
      <DialogTitle textAlign="center">Confirmação</DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '16px 24px',
        }}
      >
        <DialogContentText sx={{ paddingLeft: '0px', margin: '15px 0px' }}>
          Essa ação irá remover um sorteio. Deseja continuar?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setConfirmDelete({ open: false, index: null })} color="primary">
          Cancelar
        </Button>
        <Button onClick={() => handleDeleteDraw(confirmDelete.index)} color="secondary" autoFocus>
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
